var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"allow":"camera; microphone; fullscreen; speaker; display-capture","width":"100%","height":"700px","src":_vm.meta.meeting_url,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }